/* eslint-disable import/no-mutable-exports */
import React, { ReactNode } from 'react';
import { TTemplate } from '@/helpers/createTemplate';
import {
  BoxHeading,
  BoxWrapper,
  TextTitle,
  TitleContainer,
  WrapperContainer,
} from '../styles/PrimaryWrapper.styles';
import Breadcrumb from '@/components/Breadcrumb/Breadcrumb';
import { IS_MOBILE_APP } from '@/constants/isMobileApp';

const template = (
  pageHeader?: ReactNode,
  pageHeaderChildren?: ReactNode,
  children?: any
): TTemplate => ({
  wrapper: <BoxWrapper />,
  pageHeader: (
    <BoxHeading>
      {!IS_MOBILE_APP && <Breadcrumb />}
      <TitleContainer>
        {typeof pageHeader !== 'string' ? (
          pageHeader
        ) : (
          <TextTitle as="h1">{pageHeader}</TextTitle>
        )}
        {pageHeaderChildren}
      </TitleContainer>
    </BoxHeading>
  ),
  primaryWrapperContainer: <WrapperContainer>{children}</WrapperContainer>,
});

export default template;
